import { Component, inject } from '@angular/core';
import { NgIf } from '@angular/common';
import { EventsService } from '@services/events/events.service';
import { UtilService } from '@services/util/util.service';
import { VariablesService } from '@services/variables/variables.service';
import { MatButtonModule } from '@angular/material/button';
import { InViewportModule } from 'ng-in-viewport';
import { ImgFallbackDirective } from '@directives/img-fallback/img-fallback.directive';
import { CustomDatePipe } from '@pipes/custom-date/custom-date.pipe';

@Component({
  selector: 'app-sip-story-pitch-card',
  standalone: true,
  imports: [
    NgIf,
    ImgFallbackDirective,
    CustomDatePipe,
    MatButtonModule,
    InViewportModule
  ],
  templateUrl: './sip-story-pitch-card.component.html',
  styleUrls: ['./sip-story-pitch-card.component.scss']
})
export class SipStoryPitchCardComponent {

  readonly vars = inject(VariablesService);

  public util = inject(UtilService);
  private event = inject(EventsService);

  currentDate: any = new Date();

  checkVisibility(e) {
    if (this.vars.isBrowser && this.vars.isMobile) {
      if (e?.visible === true) {
        document.getElementById('dock-section').style.visibility = 'hidden';
      } else {
        document.getElementById('dock-section').style.visibility = 'unset';
      }
    }
  }

  donatenow() {
    this.event.sendSystemEvent({ eventName: 'sip_story_card' }).subscribe(_ => _);
    document.getElementById('donate-now-button')?.click();
  }
}
